<template>
  <sdPageHeader :title="title"> </sdPageHeader>
  <Main>
    <HorizontalFormStyleWrap>
      <sdCards headless>
        <a-form
          layout="horizontal"
          :model="formState"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          labelAlign="left"
          :rules="rules"
          @finish="handleSubmit"
        >
          <!-- Field Versi -->
          <a-form-item name="version" label="Versi">
            <a-input v-model:value="formState.version" placeholder="Masukkan Versi" />
          </a-form-item>

          <!-- Field Isi -->
          <a-form-item name="content" label="Isi">
            <ckeditor :editor="editor" :config="editorConfig" v-model="formState.content" />
          </a-form-item>

          <!-- Field Bahasa -->
          <!-- <a-form-item name="language" label="Bahasa">
            <a-select v-model:value="formState.language" placeholder="Pilih Bahasa">
              <a-select-option value="id">Indonesia</a-select-option>
              <a-select-option value="en">English</a-select-option>
            </a-select>
          </a-form-item> -->

          <!-- Tombol Submit dan Batal -->
          <a-row>
            <a-col :lg="{ span: 18, offset: 6 }" :md="{ span: 15, offset: 9 }" :xs="{ span: 24, offset: 0 }">
              <div class="sDash_form-action">
                <sdButton class="sDash_form-action__btn" type="primary" size="large" htmlType="submit">
                  {{ isLoading ? 'Harap Menunggu...' : mode }}
                </sdButton>
                <router-link to="/assessment/master/informed-consent">
                  <sdButton class="sDash_form-action__btn" type="light" size="large" htmlType="button">
                    Batal
                  </sdButton>
                </router-link>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </sdCards>
    </HorizontalFormStyleWrap>
  </Main>
</template>

<script>
import { HorizontalFormStyleWrap } from '../../../../components/crud/style';
import { Main } from '../../../styled';
import { useStore } from 'vuex';
import { reactive, computed, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue';

const InformedConsentForm = {
  name: 'InformedConsentForm',
  components: { HorizontalFormStyleWrap, Main, ckeditor: CKEditor.component },
  data() {
    return {
      title: this.mode + ' Informed Consent',
    };
  },
  props: ['mode'],
  setup(props) {
    const { state, dispatch } = useStore();
    const { params } = useRoute();
    const isLoading = computed(() => state.crud.loading);
    const crud = computed(() => state.crud.data);

    // CKEditor setup
    const editor = ClassicEditor;
    const editorConfig = {
      placeholder: 'Masukkan Isi Informed Consent',
      toolbar: [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        'bulletedList',
        'numberedList',
        '|',
        'outdent',
        'indent',
        '|',
        'blockQuote',
        'insertTable',
        'undo',
        'redo',
      ],
    };

    // Handle CKEditor data changes
    const onEditorChange = (event, editor) => {
      formState.content = editor.getData();
    };

    const formState = reactive({
      version: '',
      content: '',
      // language: 'id', // Default ke Bahasa Indonesia
    });

    const rules = {
      version: [{ required: true, message: 'Versi harus diisi' }],
      content: [{ required: true, message: 'Isi harus diisi' }],
      // language: [{ required: true, message: 'Bahasa harus diisi' }],
    };

    const labelCol = {
      lg: { span: 6 },
      md: { span: 9 },
      xs: { span: 24 },
    };
    const wrapperCol = {
      lg: { span: 18 },
      md: { span: 15 },
      xs: { span: 24 },
    };

    onMounted(() => {
      // Jika mode edit, ambil data existing
      if (props.mode === 'Ubah' && params.id) {
        /* dispatch('axiosCrudGetData', `informed-consent/${params.id}`).then(() => {
          Object.assign(formState, crud.value.data);
        }); */
        if (props.mode === 'Ubah' && params.id) {
          dispatch('axiosCrudGetData', `informed-consent/${params.id}`);
        }
      }
    });

    watch(crud, newCrud => {
      if (newCrud && newCrud.data) {
        formState.content = newCrud.data.content;
        formState.version = newCrud.data.version;
      }
    });

    const handleSubmit = values => {
      if (props.mode == 'Tambah') {
        dispatch('axiosCrudSubmitData', {
          url: 'informed-consent',
          data: values,
        });
      } else {
        dispatch('axiosDataUpdate', {
          id: params.id,
          url: 'informed-consent',
          data: values,
        });
      }
    };

    return {
      formState,
      rules,
      labelCol,
      wrapperCol,
      isLoading,
      handleSubmit,
      editor,
      editorConfig,
      onEditorChange,
    };
  },
};

export default InformedConsentForm;
</script>

<style lang="scss" scoped>
.sDash_form-action {
  margin-top: 40px;
  &__btn:not(:last-child) {
    margin-right: 20px;
  }
}
</style>
